import React from 'react'
import { useLoad } from '../../../../../../shared/hooks/load'
import { useApiBlobFileSelfRegister, useApiFormFileSelfRegister } from '../../../../../../api-new/state/storage'
import { UppyImageUpload } from '../../../../../../shared/image-upload/uppy-image-upload'
import { HERO_OUTPUT } from '../../../../../../shared/image-upload/image-upload-config'
import { Card } from '../../../../../../shared/card/card'

export const SelfRegisterLogo = ({ storageKey, selfRegisterID }) => {
  const apiFormFileSelfRegister = useApiFormFileSelfRegister()
  const apiBlobFileSelfRegister = useApiBlobFileSelfRegister()

  useLoad(
    async () => {
      await apiBlobFileSelfRegister.get(`${selfRegisterID}`)
    },
    [storageKey]
  )

  const resolveTarget = async () => ({
    url: `${process.env.REACT_APP_API_STORAGE}/api/v1/file-self-register/${selfRegisterID}`,
    method: 'POST',
  })

  // Refresh via the BLOB hook — the old code called the form hook here, so the
  // preview never refreshed after upload (deliberate fix, per spec).
  const handleUploaded = async () => {
    await apiBlobFileSelfRegister.get(`${selfRegisterID}`)
  }

  const handleDelete = async () => {
    await apiFormFileSelfRegister.delete(`${selfRegisterID}`)
    apiBlobFileSelfRegister.init()
  }

  // Its own card: the logo saves on its own, never with the form's Update.
  return (
    <Card title="Logo">
      <UppyImageUpload
        previewBlob={apiBlobFileSelfRegister.blob}
        aspect={[16, 9]}
        output={HERO_OUTPUT}
        maxFileSize={500 * 1024}
        noun="logo"
        hint="Shown at 16:9 across the top of the self-register page. Best at 1280×720 or larger; a PNG keeps its transparency."
        resolveTarget={resolveTarget}
        onUploaded={handleUploaded}
        onDelete={handleDelete}
      />
    </Card>
  )
}
